import { Home } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';

import { OpeningResultCard } from './opening-result-card';
import { ResultHeader } from './result-header';
import { ResultStats } from './result-stats';

export function PostingResult() {
  const { postingResult, dismissResult } = useJobPostingContext();

  if (!postingResult) return null;

  const { scenario, summary, openings } = postingResult;

  return (
    <div className="border-fx-neutral-200 flex w-full flex-col items-center gap-6 overflow-y-auto rounded-lg border bg-white px-12 py-8 shadow-sm">
      <ResultHeader scenario={scenario} />

      <Separator />

      <ResultStats summary={summary} scenario={scenario} />

      <div className="flex w-full flex-col gap-2">
        <Typography
          variant="caption"
          className="text-fx-neutral-400 uppercase tracking-wider"
        >
          <FormattedMessage
            defaultMessage="Openings posted"
            description="Section title for the list of opening results"
          />
        </Typography>

        <ul className="flex flex-col gap-2">
          {openings.map(opening => (
            <OpeningResultCard key={opening.openingId} opening={opening} />
          ))}
        </ul>
      </div>

      <Separator />

      <Typography variant="small1" className="text-fx-neutral-900 text-center">
        {scenario === 'all-failed' ? (
          <FormattedMessage
            defaultMessage="You were not charged for any postings."
            description="Footer message when all postings failed"
          />
        ) : (
          <FormattedMessage
            defaultMessage="We'll monitor performance and highlight when your posting needs attention."
            description="Footer message after successful or partial job posting"
          />
        )}
      </Typography>

      <Button
        type="button"
        className="bg-gradient-to-b from-[#3935ff] to-[#8f00ff] text-white hover:opacity-90"
        onClick={dismissResult}
      >
        <Home className="size-4" />
        <FormattedMessage
          defaultMessage="Dashboard"
          description="Button to navigate to dashboard after posting"
        />
      </Button>
    </div>
  );
}
